export const pageSectionMap = {
  'en-US': {
    blog: {
      '/blog': { name: 'Blog', sectionUrl: '/blog' },
      '/blog/rpa': { name: 'RPA', sectionUrl: '/blog/rpa' },
      '/blog/robotic-process-automation': {
        name: 'RPA',
        sectionUrl: '/blog/rpa',
      },
      '/blog/ai': { name: 'Artificial Intelligence', sectionUrl: '/blog/ai' },
      '/blog/artificial-intelligence': {
        name: 'Artificial Intelligence',
        sectionUrl: '/blog/ai',
      },
      '/blog/industry-solutions': {
        name: 'Industry Solutions',
        sectionUrl: '/blog/industry-solutions',
      },
      '/blog/product-and-updates': {
        name: 'Product',
        sectionUrl: '/blog/product-and-updates',
      },
      '/blog/digital-transformation': {
        name: 'Digital Transformation',
        sectionUrl: '/blog/digital-transformation',
      },
      '/blog/automation': {
        name: 'Automation',
        sectionUrl: '/blog/automation',
      },
      // secondary blogs
      '/hr-blog': {
        name: 'Inside The Rocketship',
        sectionUrl: '/inside-the-rocketship',
      },
      '/inside-the-rocketship': {
        name: 'Inside The Rocketship',
        sectionUrl: '/inside-the-rocketship',
      },
      '/inside-the-rocketship/stories': {
        name: 'Stories',
        sectionUrl: '/inside-the-rocketship/stories',
      },
      '/inside-the-rocketship/events': {
        name: 'Events',
        sectionUrl: '/inside-the-rocketship/events',
      },
      '/inside-the-rocketship/podcast': {
        name: 'Podcast',
        sectionUrl: '/inside-the-rocketship/podcast',
      },
      '/inside-the-rocketship/humans-of-uipath': {
        name: 'Humans of UiPath',
        sectionUrl: '/inside-the-rocketship/humans-of-uipath',
      },
      '/inside-the-rocketship/culture-at-uipath': {
        name: 'Culture At UiPath',
        sectionUrl: '/inside-the-rocketship/culture-at-uipath',
      },
      '/inside-the-rocketship/tech-stories': {
        name: 'Tech Stories',
        sectionUrl: '/inside-the-rocketship/tech-stories',
      },
      '/community-blog': {
        name: 'Community Blogs',
        sectionUrl: '/community-blog',
      },
      '/community-blog/community-news': {
        name: 'Community News',
        sectionUrl: '/community-blog/community-news',
      },
      '/community-blog/developer-interviews': {
        name: 'Developer Interviews',
        sectionUrl: '/community-blog/developer-interviews',
      },
      '/community-blog/tutorials': {
        name: 'Tutorials',
        sectionUrl: '/community-blog/tutorials',
      },
    },
    global: {
      '/product': { name: 'Product', sectionUrl: '/product' },
      '/solutions': {
        name: 'Solutions',
        sectionUrl: '/solutions',
      },
      '/solutions/industry': {
        name: 'By Industry',
        sectionUrl: '/solutions/industry',
      },
      '/solutions/department': {
        name: 'By Department',
        sectionUrl: '/solutions/department',
      },
      '/solutions/technology': {
        name: 'By Technology',
        sectionUrl: '/solutions/technology',
      },
      '/company': {
        name: 'About Us',
        sectionUrl: '/company/about-us',
      },
      '/leadership': {
        name: 'About Us',
        sectionUrl: '/company/about-us',
      },
      '/newsroom': {
        name: 'Newsroom',
        sectionUrl: '/newsroom',
      },
      '/resources': {
        name: 'Resources',
        sectionUrl: '/resources/all',
      },
      '/resources/all': {
        name: 'Resources',
        sectionUrl: '/resources/all',
      },
      '/resources/automation-case-studies': {
        name: 'Automation Case Studies',
        sectionUrl: '/resources/automation-case-studies',
      },
      '/resources/automation-demo': {
        name: 'Automation Demo',
        sectionUrl: '/resources/automation-demo',
      },
      '/resources/automation-webinars': {
        name: 'Automation Webinars',
        sectionUrl: '/resources/automation-webinars',
      },
      '/rpa/journey': { name: 'RPA Journey', sectionUrl: '/rpa/journey' },
      '/partners': {
        name: 'Partners',
        sectionUrl: '/partners',
      },
      '/partners/become-a-partner': {
        name: 'Become a partner',
        sectionUrl: '/partners/become-a-partner',
      },
      '/legal/trust-and-security': {
        name: 'Trust and Security',
        sectionUrl: '/legal/trust-and-security',
      },
    },
  },
  'ja-JP': {
    blog: {
      '/blog': { name: 'Blog', sectionUrl: '/ja/blog' },
      '/blog/digital-transformation': {
        name: 'デジタルトランスフォーメーション（DX）',
        sectionUrl: 'ja/blog/digital-transformation',
      },
      '/blog/rpa': {
        name: 'RPA（ロボティック・プロセス・オートメーション）',
        sectionUrl: '/ja/blog/rpa',
      },
      '/blog/robotic-process-automation': {
        name: 'RPA（ロボティック・プロセス・オートメーション）',
        sectionUrl: 'ja/blog/robotic-process-automation',
      },
      '/blog/ai': {
        name: 'AI（人工知能）',
        sectionUrl: '/ja/blog/ai',
      },
      '/blog/artificial-intelligence': {
        name: 'AI（人工知能）',
        sectionUrl: '/ja/blog/ai',
      },
      '/blog/industry-solutions': {
        name: '業界別ソリューション',
        sectionUrl: '/ja/blog/industry-solutions',
      },
      '/blog/product-and-updates': {
        name: '製品・最新情報',
        sectionUrl: '/ja/blog/product-and-updates',
      },

      '/blog/automation': {
        name: '自動化',
        sectionUrl: '/ja/blog/automation',
      },
      // secondary blogs
      '/hr-blog': {
        name: 'Inside The Rocketship',
        sectionUrl: '/ja/inside-the-rocketship',
      },
      '/inside-the-rocketship': {
        name: 'Inside The Rocketship',
        sectionUrl: '/ja/inside-the-rocketship',
      },
      '/community-blog': {
        name: 'Community Blogs',
        sectionUrl: '/ja/community-blog',
      },
      '/community-blog/community-news': {
        name: 'ニュース',
        sectionUrl: '/ja/community-blog/community-news',
      },
      '/community-blog/knowledge-base': {
        name: 'ナレッジベース',
        sectionUrl: '/ja/community-blog/knowledge-base',
      },
      '/community-blog/tutorials': {
        name: 'チュートリアル',
        sectionUrl: '/ja/community-blog/tutorials',
      },
    },
    global: {
      '/product': { name: '製品', sectionUrl: '/ja/product' },
      '/solutions': {
        name: 'ソリューション',
        sectionUrl: '/ja/solutions',
      },
      '/solutions/industry': {
        name: '業界別',
        sectionUrl: '/ja/solutions/industry',
      },
      '/solutions/department': {
        name: '部門別',
        sectionUrl: '/ja/solutions/department',
      },
      '/solutions/technology': {
        name: 'テクノロジー別',
        sectionUrl: '/ja/solutions/technology',
      },
      '/company': {
        name: '会社について',
        sectionUrl: '/ja/company/about-us',
      },
      '/leadership': {
        name: '会社について',
        sectionUrl: '/ja/company/about-us',
      },
      '/newsroom': {
        name: 'ニュースルーム',
        sectionUrl: '/ja/newsroom',
        localePageName: 'Newsroom (ja-JP)',
      },
      '/resources': {
        name: '資力',
        sectionUrl: '/ja/resources/all',
      },
      '/resources/all': {
        name: '資力',
        sectionUrl: '/ja/resources/all',
      },
      '/resources/automation-case-studies': {
        name: '自動化のケーススタディ',
        sectionUrl: '/ja/resources/automation-case-studies',
      },
      '/resources/automation-demo': {
        name: '自動化デモ',
        sectionUrl: '/ja/resources/automation-demo',
      },
      '/resources/automation-webinars': {
        name: '自動化ウェビナー',
        sectionUrl: '/ja/resources/automation-webinars',
      },
      '/rpa/journey': { name: 'RPAについて', sectionUrl: '/ja/rpa/journey' },
      '/partners': {
        name: 'UiPathパートナ',
        sectionUrl: '/ja/partners',
      },
      '/partners/become-a-partner': {
        name: '協力者になる',
        sectionUrl: '/ja/partners/become-a-partner',
      },
    },
  },
  'de-DE': {
    blog: {
      '/blog': { name: 'Blog', sectionUrl: '/de/blog' },
      // secondary blogs
      '/hr-blog': {
        name: 'Inside The Rocketship',
        sectionUrl: '/de/inside-the-rocketship',
      },
      '/inside-the-rocketship': {
        name: 'Inside The Rocketship',
        sectionUrl: '/de/inside-the-rocketship',
      },
      '/inside-the-rocketship/stories': {
        name: 'Stories',
        sectionUrl: '/de/inside-the-rocketship/stories',
      },
      '/inside-the-rocketship/events': {
        name: 'Events',
        sectionUrl: '/de/inside-the-rocketship/events',
      },
      '/inside-the-rocketship/podcast': {
        name: 'Podcast',
        sectionUrl: '/de/inside-the-rocketship/podcast',
      },
      '/inside-the-rocketship/humans-of-uipath': {
        name: 'Humans of UiPath',
        sectionUrl: '/de/inside-the-rocketship/humans-of-uipath',
      },
      '/community-blog': {
        name: 'Community Blogs',
        sectionUrl: '/de/community-blog',
      },
      '/community-blog/developer-events': {
        name: 'Developer Events',
        sectionUrl: '/de/community-blog/developer-events',
      },
      '/community-blog/developer-journey': {
        name: 'Developer Journey',
        sectionUrl: '/de/community-blog/developer-journey',
      },
      '/community-blog/product-updates': {
        name: 'Product / Updates',
        sectionUrl: '/de/community-blog/product-updates',
      },
      '/community-blog/tutorials': {
        name: 'Tutorials',
        sectionUrl: '/de/community-blog/tutorials',
      },
    },
    global: {
      '/product': { name: 'Produkt', sectionUrl: '/de/product' },
      '/solutions': {
        name: 'Lösungen',
        sectionUrl: '/de/solutions',
      },
      '/partners': {
        name: 'Partner',
        sectionUrl: '/de/partners',
      },
      '/rpa/journey': { name: 'RPA-Reise', sectionUrl: '/de/rpa/journey' },
      '/newsroom': {
        name: 'Newsroom',
        sectionUrl: '/de/newsroom',
        localePageName: 'Newsroom (de-DE)',
      },
      '/company': {
        name: 'Über uns',
        sectionUrl: '/de/company/about-us',
      },
      '/leadership': {
        name: 'Über uns',
        sectionUrl: '/de/company/about-us',
      },
    },
  },
  'fr-FR': {
    blog: {
      '/blog': { name: 'Blog', sectionUrl: '/fr/blog' },
      // secondary blogs
      '/hr-blog': {
        name: 'Inside The Rocketship',
        sectionUrl: '/fr/inside-the-rocketship',
      },
      '/inside-the-rocketship': {
        name: 'Inside The Rocketship',
        sectionUrl: '/fr/inside-the-rocketship',
      },
      '/inside-the-rocketship/stories': {
        name: 'Stories',
        sectionUrl: '/fr/inside-the-rocketship/stories',
      },
      '/inside-the-rocketship/events': {
        name: 'Events',
        sectionUrl: '/fr/inside-the-rocketship/events',
      },
      '/inside-the-rocketship/podcast': {
        name: 'Podcast',
        sectionUrl: '/fr/inside-the-rocketship/podcast',
      },
      '/inside-the-rocketship/humans-of-uipath': {
        name: 'Humans of UiPath',
        sectionUrl: '/fr/inside-the-rocketship/humans-of-uipath',
      },
      '/community-blog': {
        name: 'Community Blogs',
        sectionUrl: '/fr/community-blog',
      },
      '/community-blog/developer-events': {
        name: 'Developer Events',
        sectionUrl: '/fr/community-blog/developer-events',
      },
      '/community-blog/developer-journey': {
        name: 'Developer Journey',
        sectionUrl: '/fr/community-blog/developer-journey',
      },
      '/community-blog/product-updates': {
        name: 'Product / Updates',
        sectionUrl: '/fr/community-blog/product-updates',
      },
      '/community-blog/tutorials': {
        name: 'Tutorials',
        sectionUrl: '/fr/community-blog/tutorials',
      },
    },
    global: {
      '/product': { name: 'Produits', sectionUrl: '/fr/product' },
      '/solutions': {
        name: 'Solutions',
        sectionUrl: '/fr/solutions',
      },
      '/partners': {
        name: 'Partner',
        sectionUrl: '/fr/partners',
      },
      '/rpa/journey': {
        name: 'A propos de la RPA',
        sectionUrl: '/fr/rpa/journey',
      },
      '/newsroom': {
        name: 'Newsroom',
        sectionUrl: '/fr/newsroom',
        localePageName: 'Newsroom (fr-FR)',
      },
      '/company': {
        name: 'À propos de nous',
        sectionUrl: '/fr/company/about-us',
      },
      '/leadership': {
        name: 'À propos de nous',
        sectionUrl: '/fr/company/about-us',
      },
    },
  },
  'ko-KR': {
    blog: {
      '/blog': { name: 'Blog', sectionUrl: '/ko/blog' },
      '/blog/rpa': {
        name: 'Robotic Process Automation (RPA)',
        sectionUrl: '/ko/blog/rpa',
      },
      '/blog/robotic-process-automation': {
        name: 'Robotic Process Automation (RPA)',
        sectionUrl: 'ko/blog/robotic-process-automation',
      },
      '/blog/ai': {
        name: '인공지능(AI)',
        sectionUrl: '/ko/blog/ai',
      },
      '/blog/artificial-intelligence': {
        name: '인공지능(AI)',
        sectionUrl: '/ko/blog/artificial-intelligence',
      },
      '/blog/industry-solutions': {
        name: '산업별 솔루션',
        sectionUrl: '/ko/blog/industry-solutions',
      },
      '/blog/product-and-updates': {
        name: '제품',
        sectionUrl: '/ko/blog/product-and-updates',
      },
      '/blog/digital-transformation': {
        name: '디지털 혁신',
        sectionUrl: '/ko/blog/digital-transformation',
      },
      '/blog/automation': {
        name: '자동화',
        sectionUrl: '/ko/blog/automation',
      },
      // secondary blogs
      '/hr-blog': {
        name: 'Inside The Rocketship',
        sectionUrl: '/ko/inside-the-rocketship',
      },
      '/inside-the-rocketship': {
        name: 'Inside The Rocketship',
        sectionUrl: '/ko/inside-the-rocketship',
      },
      '/inside-the-rocketship/stories': {
        name: 'Stories',
        sectionUrl: '/ko/inside-the-rocketship/stories',
      },
      '/inside-the-rocketship/events': {
        name: 'Events',
        sectionUrl: '/ko/inside-the-rocketship/events',
      },
      '/inside-the-rocketship/podcast': {
        name: 'Podcast',
        sectionUrl: '/ko/inside-the-rocketship/podcast',
      },
      '/inside-the-rocketship/humans-of-uipath': {
        name: 'Humans of UiPath',
        sectionUrl: '/ko/inside-the-rocketship/humans-of-uipath',
      },
      '/community-blog': {
        name: 'Community Blogs',
        sectionUrl: '/ko/community-blog',
      },
      '/community-blog/developer-events': {
        name: 'Developer Events',
        sectionUrl: '/ko/community-blog/developer-events',
      },
      '/community-blog/developer-journey': {
        name: 'Developer Journey',
        sectionUrl: '/ko/community-blog/developer-journey',
      },
      '/community-blog/product-updates': {
        name: 'Product / Updates',
        sectionUrl: '/ko/community-blog/product-updates',
      },
      '/community-blog/tutorials': {
        name: 'Tutorials',
        sectionUrl: '/ko/community-blog/tutorials',
      },
    },
    global: {
      '/product': { name: '제품', sectionUrl: '/ko/product' },
      '/solutions': {
        name: '솔루션',
        sectionUrl: '/ko/solutions',
      },
      '/partners': {
        name: '파트너',
        sectionUrl: '/ko/partners',
      },
      '/rpa/journey': { name: 'RPA 여정', sectionUrl: '/ko/rpa/journey' },
      '/company': {
        name: '회사',
        sectionUrl: '/ko/company/about-us',
      },
      '/leadership': {
        name: '회사',
        sectionUrl: '/ko/company/about-us',
      },
    },
  },
  'pt-BR': {
    blog: {
      '/blog': { name: 'Blog', sectionUrl: '/pt/blog' },
    },
    global: {
      '/company': {
        name: 'Sobre nós',
        sectionUrl: '/pt/company/about-us',
      },
      '/leadership': {
        name: 'Sobre nós',
        sectionUrl: '/pt/company/about-us',
      },
    },
  },
  // Breadcrumbs for Chinese Site need to be added here
  'zh-CN': {
    blog: {},
    global: {
      '/company': {
        name: '关于我们',
        sectionUrl: '/company/about-us',
      },
      '/leadership': {
        name: '关于我们',
        sectionUrl: '/company/about-us',
      },
    },
  },

  // Breadcrumbs for Taiwan Site need to be added here
  'zh-Hant-TW': {
    blog: {},
    global: {
      '/company': {
        name: 'Taiwan',
        sectionUrl: '/tw/company/about-us',
      },
      '/leadership': {
        name: 'Taiwan',
        sectionUrl: '/tw/company/about-us',
      },
    },
  },
}
